import React from "react";
import HeaderOrbit from "../../components/HeaderOrbit";
import Container from "../../components/Container";
import FlexLayout from "../../components/LayoutFlex";
import { Text, Flex, Box, LetterIcon, TeleIcon } from "@edricphan2022/uikit";
import ContentHeader from "../../components/ContentHeader";
import FormOrbit from "../HomeOrbit/FormOrbit";
import Gifv4 from "../../assets/servicez/gif4.gif";
import Picture from "../../components/Picture";

import { Wrapper, HowWorksStyle, BoxInTouch } from "./styled";

const ContactUs = () => {
  return (
    <Wrapper>
      <HowWorksStyle>
        <HeaderOrbit />
        <BoxInTouch>
          <Container>
            <FlexLayout className="cus-intouch-orbit">
              <Box>
                <ContentHeader text="" title="Have a project or a partnership in mind?" />
                <Text>
                  We’d love to hear from you.
                  <br /> Send us a message, visit our offices or book a meeting
                </Text>
                <Box pt="46px">
                  <Flex>
                    <LetterIcon />
                    <Text pl="16px">info@technologyorbit.com</Text>
                  </Flex>
                  <Flex pt="7px">
                    <TeleIcon />
                    <Text pl="16px">@technologyorbit</Text>
                  </Flex>
                  <Box>
                    <Picture className="cus-gif" url={Gifv4} />
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box>
                  <FormOrbit />
                </Box>
              </Box>
            </FlexLayout>
          </Container>
        </BoxInTouch>
      </HowWorksStyle>
    </Wrapper>
  );
};

export default ContactUs;
